import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useDismissedUIElements } from "@/hooks/useDismissedUIElements";

interface MilestonesEducationalNoticeProps {
  jobId: string;
}

export const MilestonesEducationalNotice = ({ jobId }: MilestonesEducationalNoticeProps) => {
  const { isDismissed, dismiss, isDismissing } = useDismissedUIElements(
    'milestones_educational_notice',
    { job_id: jobId }
  );

  if (isDismissed) return null;

  return (
    <Alert className="bg-blue-50 border-blue-200 dark:bg-blue-950/20 dark:border-blue-800 relative">
      <Info className="h-4 w-4 text-blue-600 dark:text-blue-400" />
      <AlertDescription className="text-sm text-blue-900 dark:text-blue-100 pr-8">
        <p className="mb-2">
          Milestones are key events in the lifecycle of your Job. Every job starts with two Milestones 
          by default, Art Files Ready for Production and Final Delivery Due. We recommend that you add 
          milestones to create a more detailed timeline, but it's not required. Both parties have an 
          opportunity to revise the Milestones, and both need to approve before a Purchase Order can be issued.
        </p>
        <p>
          Each User Milestone will receive automated email reminders leading up to the due date.
        </p>
      </AlertDescription>
      <Button
        variant="ghost"
        size="sm"
        className="absolute top-3 right-3 h-6 w-6 p-0 hover:bg-blue-100 dark:hover:bg-blue-900"
        onClick={() => dismiss()}
        disabled={isDismissing}
        aria-label="Dismiss notice"
      >
        <X className="h-4 w-4 text-blue-600 dark:text-blue-400" />
      </Button>
    </Alert>
  );
};
